<template>
  <div id="dummy-html">
    <h5 class="mb-3">
      {{ dataComponent.name }}
    </h5>

    <div
      v-if="!showFrame"
      style="text-align: center;"
    >
      <div class="lds-ellipsis"><div/><div/><div/><div/></div>
    </div>
    <iframe
      v-if="showFrame"
      :src="urlFrame"
      class="iframe-box"
    />
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-console, no-unused-vars,
no-eval, no-mixed-operators, no-lonely-if, no-underscore-dangle, no-param-reassign, no-plusplus */

import axios from 'axios';
import Vue from 'vue';
import jwtDecode from 'jwt-decode';

export default {
  props: {
    dataComponent: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      showFrame: false,
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
      urlFrame: '',
    };
  },

  created() {
    this.generateURL();
  },

  methods: {
    async generateURL() {
      let x;
      const _user = this.session.user;
      let embedUrl = this.dataComponent.info ? JSON.parse(this.dataComponent.info).url : '';
      const arrValue = [];
      let index = 0;
      if (localStorage.getItem('paramEmbedUrl')) embedUrl = `${embedUrl}${encodeURI(localStorage.getItem('paramEmbedUrl'))}`;

      // eslint-disable-next-line
      async function _hitFunction(functionName, payload) {
        let y;
        const token = Vue.ls.get('Token');
        const gateUrl = localStorage.getItem('gateUrl');
        const url = `${gateUrl}nocode/function?function_name=${functionName}`;
        const body = eval(`y=${JSON.stringify(payload)}`);
        const currentIndex = index;
        index++;

        const hitApi = await axios.post(url, body, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });

        const data = hitApi.data || null;
        arrValue.push({
          index: currentIndex,
          function: functionName,
          value: data,
        });
        return data;
      }

      if (embedUrl.includes('_user') || embedUrl.includes('_hitFunction')) {
        let resEval = await eval(`x=${embedUrl}`);

        setTimeout(() => {
          arrValue.forEach((e, indexArr) => {
            const findValue = arrValue.find(f => f.index === indexArr);
            resEval = resEval.replace('[object Promise]', findValue.value);
          });

          this.urlFrame = resEval;
          this.showFrame = true;
        }, 3000);
      } else {
        this.urlFrame = String(embedUrl.replaceAll('"', ''));
        this.showFrame = true;
      }
    },
  },
};
</script>

<style lang="scss">
.iframe-box {
    border: none;
    width: 100%;
    height: 1500px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dummy/DummyEmbedUrl.vue